import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";
import DownloadIcon from "@material-ui/icons/GetApp";

function DownloadsTable({
  data,
  header,
  rowHover,
  onRowClick,
  cursor,
  maxHeight,
  downloadFile,
}) {
  const useStyles = makeStyles({
    table: {
      border: "none",
    },
    tableHead: {
      background: "#17b978",
      color: "#07444A",
    },
    tableBody: {
      background: "#07444A",
    },
    tableRow: {
      cursor: cursor,
    },
  });
  const classes = useStyles();

  return (
    <TableContainer component={Paper} style={{ maxHeight }}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            {header.map((h) => {
              return (
                <TableCell
                  align="center"
                  style={{ borderBottom: "1px solid #052B2E" }}
                >
                  {h.name}
                </TableCell>
              );
            })}
            <TableCell
              align="center"
              style={{ borderBottom: "1px solid #052B2E" }}
            >
              Ação
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.tableBody}>
          {data.map((row) => (
            <TableRow
              hover={rowHover}
              key={row.name}
              className={classes.tableRow}
            >
              {header.map((h) => {
                return (
                  <TableCell
                    align="center"
                    style={{
                      color: "whitesmoke",
                      borderBottom: "1px solid #052B2E",
                    }}
                  >
                    {row[h.id]}
                  </TableCell>
                );
              })}
              <TableCell
                align="center"
                style={{
                  color: "whitesmoke",
                  borderBottom: "1px solid #052B2E",
                }}
              >
                <DownloadIcon
                  style={{ color: "whitesmoke", cursor: "pointer" }}
                  onClick={() => downloadFile(row)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

DownloadsTable.propTypes = {
  data: PropTypes.array.isRequired,
  header: PropTypes.array.isRequired,
  rowHover: PropTypes.bool,
  cursor: PropTypes.string,
  maxHeight: PropTypes.string,
  downloadFile: PropTypes.func,
};

DownloadsTable.defaultProps = {
  data: [],
  header: [],
  rowHover: true,
  cursor: "default",
  maxHeight: "600px",
};

export default DownloadsTable;
